import { createApiClient, getRuntimeConfig, useAuth, type ApiClient } from '@berky/auth'
import { useMemo } from 'react'

/** API-Zugang für den globalen Dialog außerhalb einer Modulroute. */
export function useFeedbackApi(): ApiClient {
  const { getAccessToken, reportApiAuthError } = useAuth()
  const { platformScope } = getRuntimeConfig()
  const scopes = useMemo(() => (platformScope ? [platformScope] : []), [platformScope])

  return useMemo(
    () =>
      createApiClient({
        baseUrl: '/api/feedback',
        scopes,
        getAccessToken,
        onAuthError: reportApiAuthError,
      }),
    [getAccessToken, reportApiAuthError, scopes],
  )
}
